import React from 'react';
import styles from './buttonStyles.scss'; // Import the SCSS file here
import Loader from '../loader/loader'; // Assuming you already have a loader component

const Button = ({
  onClick,
  text,
  loading = false,
  disabled,
  type = 'default',
  className = '',
  id = ''
}) => {
  const buttonClass = `${styles['action-button']} ${
    type === 'white-border'
      ? styles['action-button-white-background-orange-border']
      : ''
  } ${disabled || loading ? 'disabled-button' : ''} ${className}`;

  return (
    <button
      id={id}
      onClick={onClick}
      className={buttonClass}
      disabled={disabled || loading}
    >
      <div className={styles.btnTextWrapper}>
        <div>{text}</div>
        {loading && (
          <Loader
            imgStyles={{ height: '16px', width: '16px' }}
            messageStyles={{ display: 'none' }}
          />
        )}
      </div>
    </button>
  );
};

export default Button;
